import type { TranslationPairs } from '@athena-lib/ProductWizard/types';

export default class TranslationService {
  public static getTranslationsFromMap(
    map: TranslationPairs,
    controller: string,
    values: string[],
    type: string,
  ): TranslationPairs {
    return values.reduce((translations: Record<string, string>, value: string) => {
      translations[value] = this.getTranslationFromMap(map, controller, type, value);

      return translations;
    }, {});
  }

  public static getTranslationFromMap(
    map: TranslationPairs,
    controller: string,
    type: string,
    key: string,
  ): string {
    const searchKey = `${controller}_${type}_${key}`;
    return map[searchKey] ?? key;
  }
}
